import { memo } from 'react';

import { MemberAdd } from '@air/next-icons';
import { Button } from '@air/primitive-button';

export type ShareLinkTeamInviteNudgePanelProps = {
  onInviteClick: () => void;
  workspaceName?: string;
};

export const ShareLinkTeamInviteNudgePanel = memo(
  ({ onInviteClick, workspaceName = 'workspace' }: ShareLinkTeamInviteNudgePanelProps) => {
    return (
      <div
        className="mt-3 rounded-6 border border-blue-3 bg-blue-1 p-6 shadow-popover"
        data-testid="SHARE_LINK_TEAM_INVITE_NUDGE"
      >
        <p className="font-semibold text-16 text-gray-12">Gather your team in Air</p>
        <p className="mt-1 text-14 text-gray-12">All plans have unlimited seats to make collaboration seamless.</p>
        <Button
          appearance="outline"
          className="mt-3 max-w-full overflow-hidden"
          color="blue"
          onClick={onInviteClick}
          prefix={<MemberAdd className="size-4" />}
          size="medium"
          type="button"
        >
          <span className="truncate">Invite to {workspaceName}</span>
        </Button>
      </div>
    );
  },
);

ShareLinkTeamInviteNudgePanel.displayName = 'ShareLinkTeamInviteNudgePanel';
